import React, { useEffect, Fragment, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { LocalService } from "../core/services";
import { ErrorBoundary } from './error-boundary';
import {
  Loading,
  SwitchLayer1,
  UserLogin,
  SwitchLayer2,
} from "../redux/action";
import { AnimatePresence, motion } from 'framer-motion';
import WhatsNewModal from "../components/whats-new/WhatsNewModal";
import { useWhatsNewAnnouncement, getSubscriptionRoute, getAccountAudienceFromPathname } from "../hooks/whatsNew";

interface Props {
  isLogin: any;
  Component: any;
  userId: any;
  accountId: any;
  influencerId: any;
  ownerAccountType: any;
  switchLayer1: (data: any) => void;
  SwitchLayer2: (data: any) => void;
  UserReducer: (data: any) => void;
  // IsUserLogged: (data: any) => void;
}

const localService = new LocalService();

const ProtectedRoute: React.FC<Props> = (props: Props) => {
  const { Component } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useSearchParams();
  const [renderComponent, setRenderComponent] = useState(false);
  // Restricted to direct influencer/brand self-serve users only — agency,
  // talent-partner (including while they drive a managed influencer/brand
  // dashboard), and every other section (/switch/*, /print/invoice, etc.) get
  // null here and the hook stays a no-op.
  const whatsNewAudience = getAccountAudienceFromPathname(location.pathname, props.ownerAccountType);
  const { config: pendingWhatsNew, dismiss: dismissWhatsNew, alreadySubscribed } = useWhatsNewAnnouncement(
    whatsNewAudience,
    renderComponent ? props.userId : null,
    renderComponent ? { user_id: props.userId, account_id: props.accountId, influencer_id: props.influencerId } : null
  );

  useEffect(() => {
    const userReducer: any = localService.getStorageItem("userreducer");
    const getswitchAccount: any = localService.getStorageItem("switchaccount");
    const activeAccount: any = localService.getStorageItem("activeaccount");
    const getKey = searchParams[0].get('key');
    if (userReducer && getswitchAccount) {
      props.UserReducer(JSON.parse(userReducer));
      props.switchLayer1(JSON.parse(getswitchAccount));
      props.SwitchLayer2(JSON.parse(activeAccount));
      // props.IsUserLogged(true);
    } else if (!props.isLogin) {
      let navigateUrl = '/login'
      if (getKey) {
        if (window.location.href.includes('influencer/campaign')) {
          navigateUrl = window.location.href.replace(window.location.origin, '');
          setRenderComponent(true);
        }
      }
      navigate(navigateUrl);
    }
  }, []);


  useEffect(() => {
    if (props.isLogin) {
      setRenderComponent(props.isLogin)
    }
  }, [props.isLogin])


  // const handleRouteChange = () => {
  //   setOpen(true)
  // }

  return <Fragment>
    {
      renderComponent &&

      <ErrorBoundary>
        <Component />
      </ErrorBoundary>
    }
    {
      renderComponent && pendingWhatsNew &&

      <WhatsNewModal
        config={pendingWhatsNew}
        alreadySubscribed={alreadySubscribed}
        onClose={() => dismissWhatsNew()}
        onPrimaryAction={() => {
          dismissWhatsNew();
          if (pendingWhatsNew.requiresSubscription) {
            // Already entitled — send them to use the feature instead of the subscription page.
            navigate(alreadySubscribed ? '/influencer/zap' : getSubscriptionRoute(location.pathname));
          } else if (pendingWhatsNew.ctaRoute) {
            navigate(pendingWhatsNew.ctaRoute);
          }
        }}
      />
    }
  </Fragment>
};

const mapStateToProps = (state: any) => {
  return {
    isLogin: state.UserReducer.IsUserLogged,
    userId: state.UserReducer?.UserData?.user_id,
    accountId: state.UserReducer?.UserData?.account_id,
    influencerId: state.UserReducer?.UserData?.influencer_id,
    // The OWNING account, which stays 'Agency'/'Talent Partner' even while they
    // operate a managed influencer's or brand's dashboard.
    ownerAccountType: state.SwitchLayer2Reducer?.switchUser?.account_type,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    // IsUserLogged: (data: any) => dispatch(UserLogin(data)),
    loading: (data: any) => dispatch(Loading(data)),
    switchLayer1: (data: any) => dispatch(SwitchLayer1(data)),
    UserReducer: (data: any) => dispatch(UserLogin(data)),
    SwitchLayer2: (data: any) => dispatch(SwitchLayer2(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtectedRoute);

export { connectToRedux as ProtectedRoute };
